import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "geetest-container" }

import { ref, watch, onMounted, onUnmounted } from 'vue';
// 极验无需第三方Vue组件，直接通过 window.initGeetest4 初始化
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeetestCaptcha',
  props: {
  onSuccess: {
    type: Function,
    required: false,
    default: () => undefined
  },
  // 展现形式：float | popup | bind
  product: {
    type: String,
    required: false,
    default: 'float'
  },
  // 全局缩放比例
  rem: {
    type: Number,
    required: false,
    default: 1
  }
},
  emits: ['token-change', 'ready'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;
const containerId = `geetest-container-${Math.random().toString(36).slice(2)}`;
const captchaObjRef = ref<any>(null);
const validatePayload = ref<any>(null);
const ready = ref(false);
const isInitialized = ref(false);
const isDestroyed = ref(false);

// 极验 onSuccess 时，回传四个字段
const emitValidate = () => {
  if (!validatePayload.value) return;
  emit('token-change', validatePayload.value);
  if (props.onSuccess) props.onSuccess(validatePayload.value);
};

// 处理错误
const handleError = (errorCode: string) => {
  if (isDestroyed.value) return;
  ElMessage.error('验证失败，请重试');
  resetCaptcha();
};

// 处理过期
const handleExpired = () => {
  if (isDestroyed.value) return;
  resetCaptcha();
};

// 重置
const resetCaptcha = () => {
  if (isDestroyed.value) return;
  try {
    if (captchaObjRef.value) {
      captchaObjRef.value.reset();
    }
  } catch (error) {
    // ignore
  }
  validatePayload.value = null;
};

// 初始化与重载
const initCaptcha = () => {
  isInitialized.value = true;
  ready.value = false;
  const tryInit = () => {
    const init = (window as any).initGeetest4 as undefined | ((config: any, cb: (obj: any) => void) => void);
    if (typeof init !== 'function') {
      setTimeout(tryInit, 100);
      return;
    }
    const initConfig: any = {
      captchaId: '5b2031bd5ba332ece9e9c3c93d832420',
      product: props.product || 'float',
      rem: props.rem || 1,
    };
    if ((props.product || 'float') === 'float') {
      initConfig.nativeButton = { width: '100%', height: '44px' };
    }
    init(initConfig, (captchaObj: any) => {
      captchaObjRef.value = captchaObj;
      // bind 模式下 appendTo 无效，需跳过。其他模式正常 appendTo。
      const chain = (props.product || 'float') === 'bind'
        ? captchaObj
        : captchaObj.appendTo(`#${containerId}`);
      chain
        .onReady(() => { ready.value = true; emit('ready'); })
        .onSuccess(() => {
          const result = captchaObj.getValidate();
          if (result) {
            validatePayload.value = {
              lotNumber: result.lot_number,
              captchaOutput: result.captcha_output,
              passToken: result.pass_token,
              genTime: result.gen_time,
            };
            emitValidate();
          }
        })
        .onError(() => {
          ElMessage.error('验证失败，请重试');
          resetCaptcha();
        })
        .onClose(() => {
          // 用户关闭
        });
      // popup 模式下，ready 后直接弹出
      try {
        if ((props.product || 'float') === 'popup') {
          captchaObj.showCaptcha();
        }
      } catch (e) { /* ignore */ }
    });
  };
  tryInit();
};

// 组件挂载
onMounted(() => {
  initCaptcha();
});

// 组件销毁时清理
onUnmounted(() => {
  isDestroyed.value = true;
  isInitialized.value = false;
});

// 导出重置方法，供父组件调用
__expose({
  reset: resetCaptcha,
  // 返回四要素
  getToken: () => validatePayload.value,
  isReady: () => ready.value,
  show: () => {
    try {
      if (captchaObjRef.value) captchaObjRef.value.showCaptcha();
    } catch (e) { /* ignore */ }
  },
  // 销毁并重新加载
  reload: () => {
    try {
      if (captchaObjRef.value) {
        captchaObjRef.value.destroy();
      }
    } catch (e) { /* ignore */ }
    captchaObjRef.value = null;
    validatePayload.value = null;
    ready.value = false;
    initCaptcha();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { id: containerId })
  ]))
}
}

})